export default __webpack_public_path__ + "static/media/icon-bonus.ec3f503c.svg";